enum WizardFlowState {
  ONBOARDING = 'ONBOARDING',
  MEDIA_SOURCE = 'MEDIA_SOURCE',
  MEDIA_IMPORT = 'MEDIA_IMPORT',
  MEDIA_UPLOAD_AND_SELECT = 'MEDIA_UPLOAD_AND_SELECT',
  CUSTOMIZE_THEME = 'CUSTOMIZE_THEME',
  CUSTOMIZE_STYLE = 'CUSTOMIZE_STYLE',
  CUSTOMIZE_MUSIC = 'CUSTOMIZE_MUSIC',
  CUSTOMIZE_TEXTS = 'CUSTOMIZE_TEXTS',
  CUSTOMIZE_BUSINESS_INFO = 'CUSTOMIZE_BUSINESS_INFO',
  VIDEO_PREVIEW_CREATING = 'VIDEO_PREVIEW_CREATING',
  VIDEO_PREVIEW = 'VIDEO_PREVIEW',
  OUTPUT = 'OUTPUT',
}

enum WizardFlowAction {
  BACK = 'BACK',
  NEXT = 'NEXT',
  EDIT = 'EDIT',
}

interface IWizardFlowContextData {
  isBusiness: boolean;
  isShortFlowActive: boolean;
}

interface IWizardFlowContextActions {
  createVideoOutput();
  deactivateShortFlow();
  startWizardSession();
}

interface IWizardFlowContext
  extends IWizardFlowContextData,
    IWizardFlowContextActions {}

export {
  WizardFlowState,
  WizardFlowAction,
  IWizardFlowContextData,
  IWizardFlowContextActions,
  IWizardFlowContext,
};
